import classNames from 'classnames';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {NavLink} from 'react-router-dom';
import {Routes} from '../../../../Routes';

export function SettingsLink(props) {
    const {className, dataTestId} = props;

    const intl = useIntl();

    const linkClasses = classNames('link', className);

    return (
        <NavLink
            className={linkClasses}
            data-test-id={dataTestId ?? 'account-menu-settings-link'}
            title={intl.formatMessage({id: 'accountMenu.link.settings.title'})}
            to={Routes.ACCOUNT_SETTINGS}
        >
            <span>
                <FormattedMessage id={'accountMenu.link.settings.text'} />
            </span>
        </NavLink>
    );
}
